import { ContentfulLivePreview } from '@contentful/live-preview';
import { Asset, Entry } from 'contentful';

export const annotate = <T extends Entry | Asset>(
	entry?: T | string,
	fieldId: (string & keyof T['fields']) | '.' = '.'
) =>
	!entry
		? {}
		: typeof entry === 'string'
			? ContentfulLivePreview.getProps({
				entryId: entry,
				fieldId,
			})
			: isEntry(entry)
				? ContentfulLivePreview.getProps({
					entryId: entry.sys.id,
					fieldId,
				})
				: isAsset(entry)
					? ContentfulLivePreview.getProps({
						assetId: entry.sys.id,
						fieldId,
					})
					: {};

const isAsset = (entry: Entry | Asset): entry is Asset => entry.sys.type === 'Asset';
const isEntry = (entry: Entry | Asset): entry is Entry => entry.sys.type === 'Entry';